import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule ,FormsModule} from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { PiggyBankComponent } from './piggy-bank.component';
import { PiggyBankTutorialModule } from './piggy-bank-tutorial/piggy-bank-tutorial.module';
import { PiggyPurchaseSuccessFailureModule } from './piggy-purchase-success-failure/piggy-purchase-success-failure..module';
import { directivesModule } from 'src/app/directives/directives.module';


@NgModule({
  declarations: [
    PiggyBankComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    directivesModule,
    ComponentsModule,
    PiggyBankTutorialModule,
    PiggyPurchaseSuccessFailureModule
  ]
})
export class PiggyBankModule {}